export default "__VITE_ASSET__Izf4Ccfj__"